import { TabIndexCleaner } from './tab_index_cleaner';

angular.module('capability-ng-scheduler').directive('removeTabindexOnChange', function () {
  return {
    restrict: 'A',
    link: function (scope: ng.IScope, element: ng.IRootElementService) {
      const targetElement = element[0] as HTMLElement;
      const cleaner = new TabIndexCleaner(targetElement);

      // Start observing when the directive is initialized
      cleaner.startObserving();

      // Clean up the observer when the directive is destroyed
      scope.$on('$destroy', function () {
        cleaner.stopObserving();
      });
    }
  };
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/utilities/tabindex/tabindex_remover_directive.ts